import SentimentVeryDissatisfied from '@material-ui/icons/SentimentVeryDissatisfied';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'rebass';
import styled from 'styled-components';
import Spinner from './Spinner';
import { Translate } from 'react-redux-i18n';

const CenterContent = styled.div`
  text-align: center
`;

const Frown = styled(SentimentVeryDissatisfied)`
  color: ${(props) => props.theme.colors.grays[0]}
  font-size: 120px !important
`;

const NotFound404 = ({authLoading, message}) => (
  <Container>
    {authLoading &&
      <Spinner/>
    }
    {!authLoading &&
      <CenterContent>
        <h2><Translate value='app.not_found' /></h2>
        {!!message && <h4><Translate value={message} /></h4>}
          <Frown />
      </CenterContent>
    }
  </Container>
);

NotFound404.propTypes = {
  message: PropTypes.string
};

const mapStateToProps = (state) => {
  return {
    authLoading: state.userState.loading
  };
};

export default connect(
  mapStateToProps,
)(NotFound404);


// WEBPACK FOOTER //
// ./src/components/NotFound404.jsx